var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-0 px-sm-5 py-2" },
    [
      _c(
        "b-col",
        { attrs: { cols: "12", lg: "10" } },
        [
          _c("b-skeleton", {
            staticClass: "mb-4 mt-2",
            attrs: { animation: "fade", width: "100%", height: "1.5rem" },
          }),
          _vm._v(" "),
          _c("b-skeleton", {
            staticClass: "mb-3",
            attrs: { animation: "fade", width: "100%", height: "1rem" },
          }),
          _vm._v(" "),
          _c("b-skeleton", {
            staticClass: "mb-3",
            attrs: { animation: "fade", width: "100%", height: "1rem" },
          }),
          _vm._v(" "),
          _c("b-skeleton", {
            staticClass: "mb-3",
            attrs: { animation: "fade", width: "100%", height: "1rem" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }